var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"watermarkBox",staticClass:"component-container",class:{ 'watermask-full-screen': _vm.isFullScreen },staticStyle:{"pointer-events":"none"}},[_c('div',{ref:"scrollNotice",staticClass:"notice scrolling-notice"}),_c('div',{ref:"contentBox",staticClass:"content-box"})])
}
var staticRenderFns = []

export { render, staticRenderFns }